<template>
    <uw-content title="前端路由" padding="10px">
        <uw-table :show-header="false" :show-footer="false">
            <template slot="data">
                <vxe-table
                    ref="xTable"
                    height="100%"
                    :data="table"
                    :loading="loading"
                    :row-config="{keyField: 'id'}"
                    :tree-config="{transform: true, childrenField: 'children', rowField: 'id', parentField: 'parent', indent: 10, reserve: true}"
                    @checkbox-all="TableChangeEvent"
                    @checkbox-change="TableChangeEvent">
                    <vxe-column type="checkbox" width="45" fixed="left"></vxe-column>
                    <vxe-column min-width="150" field="name" title="菜单" tree-node></vxe-column>
                    <vxe-column min-width="150" field="path" title="路由(校验用)"></vxe-column>
                    <vxe-column min-width="150" field="icon" title="图标"></vxe-column>
                    <vxe-column min-width="150" field="sort" title="优先级"></vxe-column>
                </vxe-table>
            </template>
        </uw-table>
    </uw-content>
</template>
<script>
export default {
    data () {
        return {
            loading: false,
            table: []
        }
    },
    mounted() {
        this.TableSearch()
    },
    methods: {
        TableSearch() {
            this.loading = true
            this.$http.post('/9api/router-views/search-all').then(rps => {
                this.table = rps.data
                this.loading = false
            })
        },
        TableChangeEvent() {
        }
    },
}
</script>